import React, { useCallback } from 'react';
import { useToast } from '@chakra-ui/react';
import AdminToast from './AdminToast';
import { useAnimationToggle } from '../../Contexts/AnimationContext';

// One presentation and dismissal policy for admin action confirmations.
export default function useAdminToast() {
  const toast = useToast();
  const { animationsEnabled = true } = useAnimationToggle() || {};
  return useCallback(options => {
    const settings = { status: 'success', duration: 4000, isClosable: true, ...options };
    return toast({ ...settings, render: props => <AdminToast {...settings} {...props} animationsEnabled={animationsEnabled} /> });
  }, [toast, animationsEnabled]);
}
